import { useContext } from 'react';
import { PrivateEventBusContext } from './private-event-bus-context-instance';
import type { PrivateEventBus } from './private-event-bus';

/**
 * Returns the bus instance from context. Throws when used outside the
 * provider — the bus is a singleton and consumers must not synthesise one.
 */
export function usePrivateEventBus(): PrivateEventBus {
  const bus = useContext(PrivateEventBusContext);
  if (bus === null) {
    throw new Error('usePrivateEventBus() must be used inside a <PrivateEventBusProvider>');
  }
  return bus;
}
